import { GET_ALL_USER, UPDATE_USER_PAGINATION } from "store/actionTypes";
import { ActionType, UserDataItem } from "utils/modals";
import { PaginationTypes } from "./action";


class Users {
  result: UserDataItem[] = [];
  page: PaginationTypes = {
    page: 1,
    limit: 10,
    search:'',
    totalPages:0,
    totalRecords:0,
    sortedBy:'firstName',
    sortOrder:'1'
  };
  isLoading: boolean = false;
  count: number = 0;
}
class UserState {
  users: Users = new Users();
}
const UserReducer = (state: UserState = new UserState(), action: ActionType) => {
    switch (action.type) {
        case GET_ALL_USER:
            return { ...state, users: { ...state.users, ...action.payload } };
        case UPDATE_USER_PAGINATION:
            return {...state , users:{...state.users , page:{...state.users.page, ...action.payload}}};
        default:
            return state;
    }
};

export default UserReducer;
